











import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons';
library.add(faChevronLeft);

import { RouteState } from '@/types';
import { mapState } from 'vuex';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({ name: 'back-button' })
export default class BackButton extends Vue {
  private buttonText: string = 'Back';

  @State
  route!: RouteState;

  goBack() {
    this.$router.back();
  }

  get show() {
    return this.route.meta.showBackButton;
  }
}
